import { Tabs } from 'antd';
import React, { FC } from 'react';
import { StatisticalDistribution } from '@/presentation/pages/traffic/issues/list/statistical-distribution';
import { Attribution } from '@/presentation/pages/traffic/issues/list/table/attribution';
import { MetricSubType } from '@/proto/metric';
import { FieldList } from '@/proto/token';

interface IProps {
  token: string;
  simpleToken: string;
  fetch: boolean;
  fields?: FieldList;
}

export const ProblemList: FC<IProps> = (props) => {
  const { simpleToken } = props;

  return (
    <div>
      <Tabs defaultActiveKey={'attribution'}>
        <Tabs.TabPane tab={'异常个例'} key={'attribution'}>
          <Attribution {...props} />
        </Tabs.TabPane>
        <Tabs.TabPane tab={'统计分布'} key={'statistics'}>
          <StatisticalDistribution
            timeWindow={props.fields?.timeWindow || 0}
            token={simpleToken}
            metricSubType={MetricSubType.SUB_TYPE_TRAFFIC_EXCEPTION}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};
